import { useEffect, useState } from "react"
import { getResponseStats, getSearchSettings } from "./benchmarkClient"
import { uniqueCampaignIds, uniqueCountries } from "./reportData"

export function useBenchmarkReport() {
  const [countries, setCountries] = useState([])
  const [stats, setStats] = useState(null)
  const [statsStatus, setStatsStatus] = useState("loading")

  useEffect(() => {
    const controller = new AbortController()
    let cancelled = false

    async function load() {
      try {
        const settings = await getSearchSettings(controller.signal)
        if (cancelled) return
        const mappings = Array.isArray(settings?.mappings) ? settings.mappings : []
        setCountries(uniqueCountries(mappings))
        const ids = uniqueCampaignIds(mappings)
        if (ids.length < 1 || ids.length > 100) {
          setStats(null)
          setStatsStatus("unavailable")
          return
        }
        const nextStats = await getResponseStats(ids, controller.signal)
        if (cancelled) return
        setStats(nextStats)
        setStatsStatus("ready")
      } catch (error) {
        if (cancelled || error?.name === "AbortError") return
        setStats(null)
        setStatsStatus("unavailable")
      }
    }

    load()
    return () => {
      cancelled = true
      controller.abort()
    }
  }, [])

  return { countries, stats, statsStatus }
}
